import React from 'react';

const members = [
    { src: '/assets/images/comavatar/avatar_man_1.png', color: '#00BCD4' },
    { src: '/assets/images/comavatar/avatar_man_2.png', color: '#2196F3' },
    { src: '/assets/images/comavatar/avatar_woman_1.png', color: '#0D47A1' },
    { src: '/assets/images/comavatar/avatar_woman_2.png', color: '#80DEEA' },
    { src: '/assets/images/comavatar/avatar_woman_3.png', color: '#BBDEFB' },
];

const AuthCommunity = () => {
    return (
        <div className="flex items-center">
            {members.map((member, index) => (
                <div
                    key={index}
                    style={{ backgroundColor: member.color }}
                    className={`group relative w-16 h-16  rounded-full overflow-hidden border-4 border-white shadow-xl transition-all duration-500 ease-out hover:z-50 hover:-translate-y-3 hover:ml-5 hover:scale-110 cursor-pointer ${index !== 0 ? "-ml-5" : ""}`}
                >
                    <img
                        src={member.src}
                        alt=""
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                </div>
            ))}

            <div
                className="-ml-5 w-16 h-16  rounded-full bg-white/15 backdrop-blur-lg border-4 border-white flex items-center justify-center text-white font-bold text-lg transition-all duration-500 hover:scale-110 hover:-translate-y-3 cursor-pointer"
            >
                +5K
            </div>
        </div>
    );
};

export default AuthCommunity;